export default {"src":"/_next/static/media/1.3.8db99824.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};